import React from 'react';
import Sidebar from "../sidebar/Sidebar";
import Navbar from "../navbar/Navbar";
import Footer from '../footer/Footer';

function Layout({ children }) {
    return (
        <div style={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
            {/* Navbar sempre visibile */}
            <Navbar />

            <div style={{ display: 'flex', flex: 1, overflow: 'hidden' }}>
                {/* Sidebar statica a sinistra */}
                <Sidebar />

                {/* Area contenuto scrollabile */}
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    flex: 1,
                    overflow: 'hidden'
                }}>
                    <div style={{
                        flex: 1,
                        overflowY: 'auto',
                        padding: '1rem' // opzionale, migliora visuale
                    }}>
                        {children}
                    </div>

                    {/* Footer fisso sotto il contenuto scrollabile */}
                    <Footer />
                </div>
            </div>
        </div>
    );
}

export default Layout;
